<template>
  <div id="app">
    <v-app id="inspire">
      <v-navigation-drawer
          v-model="drawer"
          app
          clipped
      >
        <v-list dense>
          <v-list-item
              link
              :to="{name: 'home'}"
          >
            <v-list-item-action>
              <v-icon>fa-desktop</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Рабочий стол
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              link
              :to="{name: 'korzinka-dashboard'}"
          >
            <v-list-item-action>
              <v-icon>fa-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Главная
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              link
              :to="{name: 'korzinka-acts-in'}"
          >
            <v-list-item-action>
              <v-icon>fa-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Акты приходов
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
              link
              :to="{name: 'korzinka-acts-out'}"
          >
            <v-list-item-action>
              <v-icon>fa-minus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Акты возвратов
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar
          app
          clipped-left
          color="primary"
          dense
          dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="align-center">
          <span class="title">Korzinka</span>
        </v-toolbar-title>
      </v-app-bar>

      <v-content>
        <v-container fluid class="">
          <router-view v-if="$store.getters.isKorzinkaLogin"/>
          <v-overlay v-else v-model="$store.getters.layoutIsLoading">
            <v-progress-circular indeterminate size="64"/>
          </v-overlay>
        </v-container>
      </v-content>

      <v-overlay :value="$store.getters.layoutIsLoading">
        <v-progress-circular indeterminate size="64"/>
      </v-overlay>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "KorzinkaLayout",
  data: () => ({
    drawer: false
  })
}
</script>